const {getCompanyByID} = require("@/components/pages/finCompanyPage/profile/graphql")
const {API, graphqlOperation} = require('@/plugins/finAmplifyModules')
const {default: store} = require('@/store')

const {
  getPortfolioComposition,
  searchShareScreenerShares,
  searchEtfScreenerEtfs,
  searchMarketCapitalizationCategorys,
  searchSharesFilteredAndSorted,
  searchETFs,
  listScreenerConfigurations,
  listEtfScreenerConfigurations,
  myWatchlists,
  getWatchlist,
  screenerPositionGroups,
  sortedDemoToolAssets,
  getDemoToolSparplanzinsen,
  searchNewsTeasers,
  getShareCompany,
  getEtf,
  getPortfolio,
  getMinimalPortfolio,
  getSamplePortfolio,
  myMinimalPortfolios,
  shareTimeSeries1Y,
  searchTopLevelRegions,
  searchTopLevelSectors,
  getRankedShares,
  getRankedEtfs,
  getPortfolioDistribution,
  getPortfolioDistributionByAssetClass,
  getSectorTimeSeries,
  searchSortedShareStrategyCategories,
  searchSortedEtfStrategyCategories,
  searchUniverses,
  getMinimalShare,
  getMinimalEtf,
  instrumentTimeSeries,
  searchStrategyInstruments,
  getLatestGeneralTerms,
  listSpeakerAdminMessages,
  getSpeakerUserMessages,
  getSpeakerAdminMessage,
  getDataProtectionFirstInfoDoc,
  getPortfolioTimeSeriesRT,
  getPortfolioTimeSeriesRTLastValues,
  getSpeakerUserUnreadMessages,
  testVersionQuery,
  getBacktrackedPortfolio,
  getShareKeyFigures,
  validateBuySellTransactions,
  getEtfScreenerConfigurationById,
  getScreenerConfigurationById,
  getFinancialDataItemFilterValuesByIdAndAssetClass,
  getScreenerResultColumns,
  listPortfolioTransactions,
} = require('@/js/finQueries')
const {
  portfolioUpdateName,
  portfolioUpdateMonitoring,
  portfolioTransactionEdit,
  portfolioTransactionDelete,
  portfolioTransactionBuy,
  portfolioTransactionSell,
  portfolioTransactionDividend,
  portfolioUpdateShareUniverse,
  portfolioCashPayOut,
  portfolioCashPayIn,
  importPortfolio,
  deletePortfolioNested,
  deletePortfolioShareEntry,
  deletePortfolioEtfEntry,
  updatePortfolioStrategy,
  createWatchlist,
  renameWatchlist,
  deleteWatchlist,
  addWatchlistEntry,
  updateWatchlistEntry,
  deleteWatchlistEntry,
  updateSpeakerMessageReadAt,
  updateSpeakerMessageReceived,
  renameScreener,
  updateScreenerHits,
  saveScreenerConfiguration,
  deleteScreenerConfiguration,
  updateEtfScreenerConfiguration,
  saveEtfScreenerConfiguration,
  deleteEtfScreenerConfiguration,
  acceptDocs,
  updateSpeakerMessage
} = require('@/js/finMutations')

const DEBUG = false

const MASTER_DATA_API = {
  searchNewsTeasers: async (limit, nextToken = undefined, filter) => {
    const params = {}
    if (!limit) {
      limit = 100
    }
    params.limit = limit

    if (nextToken) {
      params.nextToken = nextToken
    }
    if (filter) {
      params.filter = filter
    }

    const resultSet = await API.graphql(graphqlOperation(searchNewsTeasers, params)
    ).catch((e) => {
      console.error('Failed to fetch searchNewsTeasers', e)
      return undefined
    })

    if (DEBUG) console.log('searchNewsTeasers result', resultSet?.data.searchNewsArticles)
    return resultSet?.data.searchNewsArticles
  },

  topLevelSectors: async () => {
    const resultSet = await API.graphql(graphqlOperation(searchTopLevelSectors, {})
    ).catch((e) => {
      console.error('Failed to fetch sectors', e)
    })
    // console.log("topLevelSectors result", resultSet)
    if (DEBUG) console.log('topLevelSectors result', resultSet.data)
    return resultSet.data.searchSectors.items
  },

  topLevelRegions: async () => {
    console.log('topLevelRegions')
    const resultSet = await API.graphql(graphqlOperation(searchTopLevelRegions, {})
    ).catch((e) => {
      console.error('Failed to fetch regions', e)
    })
    // console.log("topLevelRegionss result", resultSet)
    if (DEBUG) console.log('topLevelRegions result', resultSet.data)
    return resultSet.data.searchRegions.items
  },

  marketCapitalizationCategorys: async () => {
    const mcFilter = null
    const mcSort = null

    const resultSet = await API.graphql(graphqlOperation(searchMarketCapitalizationCategorys, {
          filter: mcFilter,
          sort: mcSort,
          limit: 100
        }
      )
    ).catch((e) => {
      console.error('Failed to fetch market caps', e)
    })
    // console.log("marketCapitalizationCategorys result", resultSet)
    if (DEBUG) console.log('marketCapitalizationCategorys result', resultSet.data)
    return resultSet.data.searchMarketCapitalizationCategorys.items
  }

}

const COMPANY_API = {
  getCompany: async (id) => {
    return await API.graphql(graphqlOperation(getCompanyByID, {id: id}))
      .then(fetched => {
        if (DEBUG) console.log("getCompany", fetched)
        return fetched.data.getCompany
      })
  },
}

const INSTRUMENT_API = {

  searchStrategyInstruments: async (params) => {
    console.log("Calling INSTRUMENT_API.searchStrategyInstruments with", params)
    const result = await API.graphql(graphqlOperation(searchStrategyInstruments, {
      ...params
    })).then(fetched => {
      return fetched.data.searchStrategyInstruments
    })
    return result
  },
}

const SHARE_API = {
  getRankedShares: async (strategyModelID, sortDirection = "DESC") => {
    const result = await API.graphql(graphqlOperation(getRankedShares, {
      strategyModelID,
      sortDirection,
    })).then(fetched => {
      return fetched.data.listMatchingSharesByStrategy.items
    })
    console.log('getRankedShares', result)
    return result
  },
  getFinancialDataTimeSeries: async (instrumentId, range) => {
    return await API.graphql(graphqlOperation(instrumentTimeSeries, {
      instrumentId: instrumentId,
      range: range
    })).then(fetched => {
      return fetched.data
    })
  },
  getShareTimeSeries1Y: async (shareId) => {
    return await API.graphql(graphqlOperation(shareTimeSeries1Y, {
      id: shareId
    })).then(fetched => {
      return fetched.data
    })
  },
  getShareCompany: async (shareId) => {
    console.log("getShareCompany shareId", shareId)
    const result = await API.graphql(graphqlOperation(getShareCompany, {
      id: shareId
    })).then(fetched => {
      return fetched.data.getShare
    })
    console.log('getShareCompany', result)
    return result
  },
  searchSharesFilteredAndSorted: async (params) => {
    console.log("searchSharesFilteredAndSorted params", params)

    if (!params?.filter) {
      params.filter = {}
    }

    params.filter = {
      ...params.filter,
      restricted: {eq: false},
      active: {eq: true},
      covered: {eq: true},
      delisted: {eq: false}
    }

    let result = await API.graphql(graphqlOperation(searchSharesFilteredAndSorted, {
      ...params
    }))

    result.data.searchShares.items = result.data.searchShares.items.map(entry => {
      return {
        ...entry,
        instrument: {
          active: entry.active,
          covered: entry.covered,
          delisted: entry.delisted
        }
      }
    })
    console.log('searchSharesFilteredAndSorted result', result)
    return result.data.searchShares
  },
  totalShares: async () => {
    const totalSearchShares =
      `query screenerAllShares {
      searchShares (
        filter : {
          active: {eq: true},
          covered: {eq: true},
          delisted: {eq: false},
          restricted: {eq: false}
        }
      ) {
        total
      }
    }`

    return await API.graphql(graphqlOperation(totalSearchShares))
      .then(fetched => {
        return fetched.data.searchShares.total
      })
  },
  secondFilterShareScreenerShares: async (selectedItemCategory, params) => {
    const screenerFilter = SCREENER_UTIL.getShareScreenerFilter(selectedItemCategory)
    let dynamicFields = selectedItemCategory.filters.items.map(item => item.item.itemId)
    selectedItemCategory.valueFilters.items.forEach(item => dynamicFields.push(item.item.tableQuery?item.item.tableQuery:item.item.itemId))

    if (DEBUG) console.log('secondFilterShareScreenerShares', screenerFilter, selectedItemCategory, dynamicFields)

    const query = searchShareScreenerShares(dynamicFields)

    if (DEBUG) console.log('query', query, {
      filter: screenerFilter,
      ...params
    })

    const resultSet = await API.graphql(graphqlOperation(query, {
      filter: screenerFilter,
      ...params
    }))
    resultSet.data.searchShares.items = resultSet.data.searchShares.items.map(entry => {
      return {
        ...entry,
        instrument: {
          active: entry.active,
          covered: entry.covered,
          delisted: entry.delisted
        }
      }
    })
    if (DEBUG) console.log('searchShares..............', resultSet.data.searchShares)
    return resultSet.data.searchShares
  },
  searchShares: async (params) => {
    const query = searchShareScreenerShares()

    const resultSet = await API.graphql(graphqlOperation(query, {
      ...params
    }))
    resultSet.data.searchShares.items = resultSet.data.searchShares.items.map(entry => {
      return {
        ...entry,
        instrument: {
          active: entry.active,
          covered: entry.covered,
          delisted: entry.delisted
        }
      }
    })
    return resultSet.data.searchShares
  },
  secondFilterShareScreenerSharesTotal: async (selectedItemCategory) => {
    const resultSet = await SHARE_API.secondFilterShareScreenerShares(selectedItemCategory, {limit: 0})
    return resultSet.total
  },
  getMinimalShare: async (shareId) => {
    const result = await API.graphql(graphqlOperation(getMinimalShare, {id: shareId}))
    return result.data.getShare
  },
  getShareKeyFigures: async (shareId) => {
    const result = await API.graphql(graphqlOperation(getShareKeyFigures, {id: shareId}))
    return result.data.getShare
  },
}

const ETF_API = {
  getEtf: async (etfId) => {
    console.log("getEtf etfId", etfId)
    const result = await API.graphql(graphqlOperation(getEtf, {
      id: etfId
    })).then(fetched => {
      return fetched.data.getEtf
    })
    console.log('getEtf', result)
    return result
  },
  getMinimalEtf: async (etfId) => {
    const result = await API.graphql(graphqlOperation(getMinimalEtf, {id: etfId}))
    return result.data.getEtf
  },
  getRankedEtfs: async (etfStrategyModelID, sortDirection = "DESC") => {
    const result = await API.graphql(graphqlOperation(getRankedEtfs, {
      etfStrategyModelID,
      sortDirection,
    })).then(fetched => {
      console.log("getRankedEtfs etfStrategyModelID", etfStrategyModelID)
      return fetched.data.listMatchingEtfsByStrategy.items
    })
    console.log('getRankedEtfs', result)
    return result
  },
  searchEtfs: async (params) => {
    const query = searchETFs()

    if (!params?.filter) {
      params.filter = {}
    }

    params.filter = {
      ...params.filter,
      restricted: {eq: false},
      active: {eq: true},
      covered: {eq: true},
      delisted: {eq: false}
    }

    const resultSet = await API.graphql(graphqlOperation(query, {
      ...params
    }))
    resultSet.data.searchEtfs.items = resultSet.data.searchEtfs.items.map(entry => {
      return {
        ...entry,
        instrument: {
          active: entry.active,
          covered: entry.covered,
          delisted: entry.delisted
        }
      }
    })
    console.log('searchEtfs', resultSet.data.searchEtfs)
    return resultSet.data.searchEtfs
  },
  searchEtfs2: async (params) => {
    const query = searchEtfScreenerEtfs()
    const resultSet = await API.graphql(graphqlOperation(query, {
      ...params
    }))
    console.log('searchEtfs', resultSet.data.searchEtfs)
    return resultSet.data.searchEtfs
  },
  totalEtfs: async (assetClass) => {
    console.log("totalEtfs assetClass", assetClass)
    const totalSearchEtfs =
      `query etfScreenerAllEtfs {
      searchEtfs (
        filter : {
          active: {eq: true},
          covered: {eq: true},
          delisted: {eq: false},
          restricted: {eq: false},
          assetType: {eq: "${assetClass}"},
        }
      ) {
        total
      }
    }`

    return await API.graphql(graphqlOperation(totalSearchEtfs)).then(fetched => {
      return fetched.data.searchEtfs.total
    })
  },
  secondFilterEtfScreenerEtfs: async (selectedItemCategory, params) => {
    const screenerFilter = SCREENER_UTIL.getEtfScreenerFilter(selectedItemCategory)

    if (DEBUG) {
      console.log('secondFilterEtfScreenerEtfs screenerFilter, selectedItemCategory valueFilters rangeFilters', screenerFilter, selectedItemCategory,
        selectedItemCategory.valueFilters.items.map(item => item.item.itemId),
        selectedItemCategory.rangeFilters.items.map(item => item.item.itemId))
    }

    // set filters to display the values in the result table
    let columns = selectedItemCategory.resultColumns ? selectedItemCategory.resultColumns : []

    // adapt sector: special handling for etf screener sector => show the text from sectorTopic
    let additionalFields = []
    const fundSector = columns.find(item => item.includes('fundSector'))
    if (fundSector) {
      additionalFields.push("sectorTopic")
    }
    // adapt fundNiche: special handling for etf screener (commodities) fundNicheCode => show the text from fundNiche
    const fundNicheCode = columns.find(item => item.includes('fundNicheCode'))
    if (fundNicheCode) {
      additionalFields.push("fundNiche")
    }
    console.log("columns, additionalFields", columns, additionalFields)

    const query = searchEtfScreenerEtfs(columns.concat(additionalFields))

    if (DEBUG) {
      console.log('searchEtfScreenerEtfs query', query, {filter: screenerFilter, ...params})
    }

    const resultSet = await API.graphql(graphqlOperation(query, {
      filter: screenerFilter,
      ...params
    }))
    resultSet.data.searchEtfs.items = resultSet.data.searchEtfs.items.map(entry => {
      return {
        ...entry,
        instrument: {
          active: entry.active,
          covered: entry.covered,
          delisted: entry.delisted
        }
      }
    })
    if (DEBUG) console.log('searchEtfs', resultSet.data.searchEtfs)
    return resultSet.data.searchEtfs
  },
  secondFilterEtfScreenerEtfsTotal: async (selectedItemCategory) => {
    const resultSet = await ETF_API.secondFilterEtfScreenerEtfs(selectedItemCategory, {limit: 0})
    return resultSet.total
  },
}

const USER_API = {
  async getDataProtectionFirstInfoDoc() {
    let data = await API.graphql({
      query: getDataProtectionFirstInfoDoc,
      authMode: store.getters["auth/publicQueryAuthMode"]
    })
    data = data.data
    let result = []
    for (const [key, value] of Object.entries(data)) {
      if (data[key] !== null) result.push(data[key])
    }

    return result
  },

  async getLatestGeneralTerms() {
    let result = await API.graphql({
      query: getLatestGeneralTerms,
      authMode: store.getters["auth/publicQueryAuthMode"]
    })

    result = result.data.getLatestGeneralTerms
    console.log("getLatestGeneralTerms result", result)
    return result
  },
  /**
   *
   * @param publicDocIds Array of ids for public docs to be accepted
   * @param privateDocIds Array of ids for private docs to be accepted
   * @return {Object} Object with accepted public and private docs in 2 seperate arrays
   */
  async acceptDocs(documents) {
    const result = await API.graphql(graphqlOperation(
      acceptDocs, {
        input: {
          documents,
        }
      }))
    return result
  },
  async deleteUser(userId, identityId = null) {
    let deleteUserGQL = `
       mutation DeleteUserNested($userId: ID!, $identityId: String) {
        deleteUserNested(userId: $userId, identityId: $identityId) {
          id
        }
      }
    `

    let result = null

    if (userId) {
      result = await API.graphql(graphqlOperation(deleteUserGQL, {
        userId: userId,
        identityId: identityId
      }))
    }
    console.log("USER_API.deleteUser result", result)
    return result
  }
  ,
  getPortfolioComposition(portfolioId) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('getPortfolioComposition', portfolioId)
      API.graphql(graphqlOperation(getPortfolioComposition, {
          id: portfolioId
        }
      )).then(fetched => {
        // Filer deleted entries iff version is enabled
        // if (DEBUG) console.log('read all portfolio composition', fetched.data.getPortfolio)
        // let items = fetched.data.getPortfolio.shareEntries.items.filter((item, i) => !item._deleted)
        // fetched.data.getPortfolio.shareEntries.items = items
        if (DEBUG) {
          console.log('read active portfolio composition', fetched.data.getPortfolio)
        }
        resolve(fetched.data.getPortfolio)
      }).catch(reject)
    })
  },
  async getShareScreener(screenerID) {
    let result = await API.graphql(graphqlOperation(getScreenerConfigurationById, {
      id: screenerID
    }))
    let screener

    if (result.data && !result.error) {
      console.log("getShareScreener! result", result)
      screener = result.data.getScreenerConfiguration

      // adapt valueFilters values (in backend: Array of strings, in frontend: Array of objects)
      if (screener.valueFilters && screener.valueFilters.items && screener.valueFilters.items.length > 0) {
        screener.valueFilters.items.forEach(valueFiltersItem => {
          valueFiltersItem.values = valueFiltersItem.values.map(value => {
            return {id: value}
          })
        })
      }
      console.log("after adapt getShareScreeners result", screener)
    }

    return screener
  },
  async getShareScreeners() {
    let screeners = []
    let result = await API.graphql(graphqlOperation(listScreenerConfigurations))
    if (result.data && !result.error) {
      console.log("getShareScreeners! result", result)
      screeners = result.data.listOwnerScreenerConfiguration.items

      // adapt valueFilters values (in backend: Array of strings, in frontend: Array of objects)
      screeners.forEach(screener => {
        if (screener.valueFilters && screener.valueFilters.items && screener.valueFilters.items.length > 0) {
          screener.valueFilters.items.forEach(valueFiltersItem => {
            valueFiltersItem.values = valueFiltersItem.values.map(value => {
              return {id: value}
            })
          })
        }
      })
      console.log("after adapt getShareScreeners result", screeners)
    }
    return screeners
  },
  async getEtfScreener(screenerID) {
    let result = await API.graphql(graphqlOperation(getEtfScreenerConfigurationById, {
      id: screenerID
    }))
    let screener

    if (result.data && !result.error) {
      console.log("getEtfScreener screenerID / result", screenerID, result)
      screener = result.data.getEtfScreenerConfiguration

      // adapt valueFilters values (in backend: Array of strings, in frontend: Array of objects)
      if (screener.valueFilters && screener.valueFilters.items && screener.valueFilters.items.length > 0) {
        screener.valueFilters.items.forEach(valueFiltersItem => {
          valueFiltersItem.values = valueFiltersItem.values.map(value => {
            return {id: value}
          })
        })
      }

      console.log("after adapt getEtfScreeners result", screener)
    }

    return screener
  },
  async getEtfScreeners() {
    let screeners = []
    let result = await API.graphql(graphqlOperation(listEtfScreenerConfigurations))
    if (result.data && !result.error) {
      console.log("getEtfScreeners result", result)
      screeners = result.data.listOwnerEtfScreenerConfiguration.items

      // adapt valueFilters values (in backend: Array of strings, in frontend: Array of objects)
      screeners.forEach(screener => {
        if (screener.valueFilters && screener.valueFilters.items && screener.valueFilters.items.length > 0) {
          screener.valueFilters.items.forEach(valueFiltersItem => {
            valueFiltersItem.values = valueFiltersItem.values.map(value => {
              return {id: value}
            })
          })
        }
      })
      console.log("after adapt getEtfScreeners result", screeners)
    }
    return screeners
  },
  async getWatchlist(id) {
    let result = await API.graphql(graphqlOperation(getWatchlist, {
      id: id
    }))
    if (result.error) {
      //TODO handle error message
      console.error("getWatchlist error", result.error)
      return null
    }

    const res = result.data.getWatchlist

    // model completed, so that share and etf can be found under instrument. This way both instrument types can be
    // handled the same way in the watchlists
    if (res && res.watched) {
      const convertedItems = res.watched.items.map(entry => ({
        ...entry,
        instrument: entry.share || entry.etf
      }))
      res.watched.items = convertedItems
    }

    return res
  },
  async getWatchlistName(id) {
    const getWLName = 'query getWL {getWatchlist(id:"' + id + `" ) {
        id
        name
      }
    }`
    let result = await API.graphql(graphqlOperation(getWLName))
    if (result.error) {
      //TODO handle error message
      console.error(result.error)
      return null
    }
    return result.data.getWatchlist
  },
  /**
   * Function to update the alert status and the limits of a watchlist entry.
   *
   * @param watchlistId               Id of the related watchlist
   * @param instrumentId              Id of the related instrument
   * @param alertActive               Flag if the alert is active/inactive
   * @param limitsObj                 Json object that contains the lowerLimit and the upperLimit. *Not required*
   * @return {any}                    Updated WatchlistEntry
   */
  async updateWatchlistEntry(watchlistId, instrumentId, alertActive, limitsObj) {
    let input = {
      watchlistId: watchlistId,
      instrumentId: instrumentId,
      alertActive: alertActive
    }
    if (limitsObj) {
      input['lowerLimit'] = limitsObj.lowerLimit
      input['upperLimit'] = limitsObj.upperLimit
    }
    if (alertActive) {
      input['exceeded'] = null
    }

    let result = await API.graphql(graphqlOperation(updateWatchlistEntry, {input: input}))
    if (result.error) {
      //TODO handle error message
      console.error("updateWatchlistEntry result.error", result.error)
      return null
    }

    // model completed, so that share and etf can be found under instrument. This way both intrument types can be handled the same way
    // in the watchlists
    const res = result.data.updateWatchlistEntry
    res.instrument = result.data.updateWatchlistEntry.share || result.data.updateWatchlistEntry.etf
    return res
  },
}

const PORTFOLIO_API = {
  importPortfolio(filePath, name) {
    return new Promise((resolve, reject) => {
        API.graphql(graphqlOperation(importPortfolio, {filePath: filePath, name: name})).then(p => {
            if (DEBUG) console.log("importPortfolio", p)
            resolve(p.data.importPortfolio)
          }
        ).catch(reject)
      }
    )
  },
  listMinimalPortfolios(userId, nextToken) {
    return new Promise((resolve, reject) => {
        API.graphql(graphqlOperation(myMinimalPortfolios, {owner: userId, nextToken: nextToken})).then(p => {
            if (DEBUG) console.log("listMinimalPortfolios", p)
            resolve(p.data.listPortfoliosByOwner)
          }
        ).catch(reject)
      }
    )
  },
  getMinimalPortfolio(id) {
    return new Promise((resolve, reject) => {
        API.graphql(graphqlOperation(getMinimalPortfolio, {id: id})).then(p => {
            if (DEBUG) console.log("getMinimalPortfolio", p)
            resolve(p.data.getPortfolio)
          }
        ).catch(reject)
      }
    )
  },
  async getSamplePortfolio(input) {
    try {
      console.log('getSamplePortfolio input', input)
      let result = await API.graphql(graphqlOperation(getSamplePortfolio, {input: input}))

      return result.data.getSamplePortfolio
    } catch (error) {
      console.error("Failed to getSamplePortfolio with input", input, error)
      return null
    }
  },
  getPortfolio(id) {
    return new Promise((resolve, reject) => {
        API.graphql(graphqlOperation(getPortfolio, {id: id})).then(p => {
            if (DEBUG) console.log("getPortfolio", p)
            resolve(p.data.getPortfolio)
          }
        ).catch(reject)
      }
    )
  },
  async listPortfolioTransactions(portfolioId, instrumentId) {
    const result = await API.graphql(graphqlOperation(listPortfolioTransactions, {
      portfolioId: portfolioId,
      instrumentId: instrumentId
    }))

    if (DEBUG) console.log("listPortfolioTransactions", result)

    return result.data.listPortfolioTransactions
  },
  async createPortfolio(name,
                        initialCapital,
                        initialValue,
                        shareEntries,
                        etfEntries,
                        portfolioShareStrategyId,
                        portfolioShareETFStrategyId,
                        portfolioCorporateBondsETFStrategyId,
                        portfolioGovernmentBondsETFStrategyId,
                        portfolioCommoditiesETFStrategyId,
                        assetAllocationTarget,
                        investmentConsulting) {

    let savePortfolioGQL = /* GraphQL */ `
       mutation SavePortfolio($input: PortfolioInput) {
       savePortfolio(input: $input) {
          id
          name
          cash
          shareEntries {
            items {
              id
              count
              averagePrice
              assetClass
              dateAdded
              createdAt
              updatedAt
              owner
            }
            nextToken
          }
          etfEntries {
            items {
              id
              count
              averagePrice
              assetClass
              investedCapital
              owner
              dateAdded
              createdAt
              updatedAt
            }
            nextToken
          }
          timeSeriesRT {
              assetClass
              currentValue
              growthAmount
              createdAt
              owner
          }
        }
      }
`
    if (DEBUG) console.log('createPortfolio', name, initialCapital, initialValue, portfolioShareStrategyId)

    let result = await API.graphql(graphqlOperation(savePortfolioGQL, {
      input: {
        name: name,
        initialCapital: initialCapital,
        initialValue: initialValue,
        cash: initialCapital - initialValue,
        shareEntries: shareEntries,
        etfEntries: etfEntries,
        portfolioShareStrategyId: portfolioShareStrategyId,
        portfolioShareETFStrategyId: portfolioShareETFStrategyId,
        portfolioCorporateBondsETFStrategyId: portfolioCorporateBondsETFStrategyId,
        portfolioGovernmentBondsETFStrategyId: portfolioGovernmentBondsETFStrategyId,
        portfolioCommoditiesETFStrategyId: portfolioCommoditiesETFStrategyId,
        assetAllocationTarget: assetAllocationTarget,
        investmentConsulting: investmentConsulting
      }
    }))

    console.log('created portfolio', result.data.savePortfolio.id, result.data.savePortfolio.shareEntries, result.data.savePortfolio.etfEntries)
    return result.data.savePortfolio
  },
  getPortfolioTimeSeriesRTLastValues: async (portfolioId, assetClass) => {
    console.log("Calling getPortfolioTimeSeriesRTLastValue with", portfolioId, assetClass)
    const result = await API.graphql(graphqlOperation(getPortfolioTimeSeriesRTLastValues, {
      portfolioId, assetClass
    })).then(fetched => {
      console.log("getPortfolioTimeSeriesRTLastValue fetched.data", fetched.data)
      return fetched.data.getPortfolioRatioDataRealTime
    })
    console.log('getPortfolioTimeSeriesRTLastValue result', result)
    return result
  },
  getPortfolioTimeSeriesRT: async (id, assetClass) => {
    console.log("Calling getPortfolioTimeSeriesRT with", id, assetClass)
    const result = await API.graphql(graphqlOperation(getPortfolioTimeSeriesRT, {
      id, assetClass
    })).then(fetched => {
      console.log("getPortfolioTimeSeriesRT fetched.data", fetched.data)
      return fetched.data.getPortfolio.timeSeriesRT
    })
    console.log('getPortfolioTimeSeriesRT result', result)
    return result
  },
  getPortfolioDistribution: async (portfolioId) => {
    console.log("Calling getPortfolioDistribution with", portfolioId)
    const result = await API.graphql(graphqlOperation(getPortfolioDistribution, {
      portfolioId
    })).then(fetched => {
      console.log("getPortfolioDistribution fetched.data", fetched.data)
      return fetched.data.getPortfolio.distributions
    })
    console.log('getPortfolioDistribution result', result)
    return result
  },
  getPortfolioDistributionByAssetClass: async (portfolioId, assetClass) => {
    console.log("Calling getPortfolioDistributionByAssetClass with", portfolioId, assetClass)
    const result = await API.graphql(graphqlOperation(getPortfolioDistributionByAssetClass, {
      portfolioId,
      assetClass
    })).then(fetched => {
      console.log("getPortfolioDistributionByAssetClass fetched.data", fetched.data)
      return fetched.data.getPortfolioDistributionByAssetClass
    })
    console.log('getPortfolioDistributionByAssetClass', result)
    return result
  },
  async searchUniverses() {
    let result = await API.graphql(graphqlOperation(searchUniverses))
    console.log("result.data.searchUniverses.items res", result.data.searchUniverses.items)
    return result.data.searchUniverses.items
  },
  async updateShareUniversePortfolio(id, shareUniverse) {
    console.log('updateShareUniversePortfolio', id, shareUniverse)
    let result
    if (id) {
      result = await API.graphql(graphqlOperation(portfolioUpdateShareUniverse, {
        input: {
          id: id,
          portfolioShareUniverseId: shareUniverse
        }
      }))
    }
    console.log('portfolio shareUniverse saved result', result)
    return result
  },
  // updates or removes the strategy from the portfolio for the asset class SHARE
  async updateSharePortfolioStrategy(id, strategyID) {
    let result = null
    if (id) {
      result = await API.graphql(graphqlOperation(updatePortfolioStrategy, {
        input: {
          id: id,
          portfolioShareStrategyId: strategyID
        }
      }))
    }
    return result
  },
  // updates or removes the strategy from the portfolio for the asset class SHARE_ETF
  async updateShareETFPortfolioStrategy(id, strategyID) {
    let result = null
    if (id) {
      result = await API.graphql(graphqlOperation(updatePortfolioStrategy, {
        input: {
          id: id,
          portfolioShareETFStrategyId: strategyID
        }
      }))
    }
    return result
  },
  // updates or removes the strategy from the portfolio for the asset class CORPORATE_BONDS_ETF
  async updateCorporateBondsETFPortfolioStrategy(id, strategyID) {
    let result = null
    if (id) {
      result = await API.graphql(graphqlOperation(updatePortfolioStrategy, {
        input: {
          id: id,
          portfolioCorporateBondsETFStrategyId: strategyID
        }
      }))
    }
    return result
  },
  // updates or removes the strategy from the portfolio for the asset class GOVERNMENT_BONDS_ETF
  async updateGovernmentBondsETFPortfolioStrategy(id, strategyID) {
    let result = null
    if (id) {
      result = await API.graphql(graphqlOperation(updatePortfolioStrategy, {
        input: {
          id: id,
          portfolioGovernmentBondsETFStrategyId: strategyID
        }
      }))
    }
    return result
  },
  // updates or removes the strategy from the portfolio for the asset class COMMODITIES_ETF
  async updateCommoditiesETFPortfolioStrategy(id, strategyID) {
    let result = null
    if (id) {
      result = await API.graphql(graphqlOperation(updatePortfolioStrategy, {
        input: {
          id: id,
          portfolioCommoditiesETFStrategyId: strategyID
        }
      }))
    }
    return result
  },
  async updatePortfolioMonitoring(id, enableMonitoring) {
    let result = null
    if (id) {
      result = await API.graphql(graphqlOperation(portfolioUpdateMonitoring, {
        input: {
          id: id,
          deactivateFinAlert: !enableMonitoring
        }
      }))
      result = result.data.updatePortfolio
    }

    return result
  },
  async renamePortfolio(id, name) {
    let result = null

    if (id && name) {
      result = await API.graphql(graphqlOperation(portfolioUpdateName, {
        input: {
          id: id,
          name: name
        }
      }))
      result = result.data.updatePortfolio
    }

    return result
  },
  async deletePortfolioConfiguration(configuration) {
    let result = null
    if (configuration.id) {
      result = await API.graphql(graphqlOperation(deletePortfolioNested, {
        id: configuration.id
      }))
      console.log('finAPI.deletePortfolioConfiguration', result)
      return result
    }
  },
  async cashPayIn(portfolioId, cashAmount, dateAdded) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('cashPayIn', portfolioId, cashAmount, dateAdded)
      API.graphql(graphqlOperation(portfolioCashPayIn, {
          portfolioId: portfolioId,
          cashAmount: cashAmount,
          dateAdded: dateAdded
        }
      )).then(updated => {
        console.log('updated portfolio cash pay in', updated.data.portfolioCashPayIn?.id)
        resolve(updated.data.portfolioCashPayIn)
      }).catch(reject)
    })
  },
  async cashPayOut(portfolioId, cashAmount, dateAdded) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('cashPayOut', portfolioId, cashAmount, dateAdded)
      API.graphql(graphqlOperation(portfolioCashPayOut, {
          portfolioId: portfolioId,
          cashAmount: cashAmount,
          dateAdded: dateAdded
        }
      )).then(updated => {
        console.log('updated portfolio cash pay out', updated.data.portfolioCashPayOut.id)
        resolve(updated.data.portfolioCashPayOut)
      }).catch(reject)
    })
  },
  async transactionEdit(portfolioId, actionTimestamp, transaction, count, realizedPrice, realizedFees,
                        realizedTimestamp, cashAmount, dps) {
    if (DEBUG) {
      console.log('transactionEdit', portfolioId, actionTimestamp, transaction, count, realizedPrice,
        realizedFees, realizedTimestamp, cashAmount, dps)
    }

    const response = await API.graphql(graphqlOperation(portfolioTransactionEdit, {
        input: {
          portfolioId: portfolioId,
          actionTimestamp: actionTimestamp,
          transaction: transaction,
          count: count,
          realizedPrice: realizedPrice,
          realizedFees: realizedFees,
          realizedTimestamp: realizedTimestamp,
          cashAmount: cashAmount,
          dps: dps
        }
      }
    ))

    const result = response.data.portfolioTransactionEdit
    console.log('updated portfolio transaction', result)
    return result
  },
  async validateBuySellTransactions(portfolioId, instruments, transactionType) {
    let transactionData = []
    instruments.forEach(i => {
      transactionData.push({
        instrumentId: i.id,
        count: i.count,
        price: i.latestPrice.price,
        dateAdded: i.date.toISOString(),
        fees: i.fees
      })
    })
    console.log('validateBuySellTransactions: PortfolioID:', portfolioId, 'transactionData:', transactionData, 'transactionType:', transactionType)

    return new Promise((resolve, reject) => {
      API.graphql(graphqlOperation(validateBuySellTransactions, {
          input: {
            portfolioId: portfolioId,
            transactions: transactionData
          },
          transactionType: transactionType
        }
      )).then(response => {
        console.log('validated Transaction', response.data.validateBuySellTransactions)
        resolve(response.data.validateBuySellTransactions)
      }).catch(reject)
    })
  },

  async transactionBuyInstruments(portfolioId, instruments) {
    let transactionData = []
    instruments.forEach(i => {
      transactionData.push({
        instrumentId: i.id,
        count: i.count,
        price: i.latestPrice.price,
        dateAdded: i.date.toISOString(),
        fees: i.fees
      })
    })

    return new Promise((resolve, reject) => {
      API.graphql(graphqlOperation(portfolioTransactionBuy, {
          input: {
            portfolioId: portfolioId,
            transactions: transactionData
          }
        }
      )).then(response => {
        console.log('created portfolio BUY transaction', response.data.portfolioTransactionBuy)
        resolve(response.data.portfolioTransactionBuy)
      }).catch(reject)
    })
  },
  async transactionSellInstruments(portfolioId, instruments) {
    console.log('sell instruments from portfolio ' + portfolioId, instruments)

    let transactionData = []
    instruments.forEach(i => {
      transactionData.push({
        instrumentId: i.id,
        count: i.count,
        price: i.latestPrice.price,
        dateAdded: i.date.toISOString(),
        fees: i.fees
      })
    })

    return new Promise((resolve, reject) => {
      API.graphql(graphqlOperation(portfolioTransactionSell, {
          input: {
            portfolioId: portfolioId,
            transactions: transactionData
          }
        }
      )).then(response => {
        console.log('created portfolio sell transactions', response.data.portfolioTransactionSell)
        resolve(response.data.portfolioTransactionSell)
      }).catch(reject)
    })
  },

  async transactionDelete(portfolioId, actionTimestamp, transaction) {
    const response = await API.graphql(graphqlOperation(portfolioTransactionDelete, {
      input: {
        portfolioId: portfolioId,
        actionTimestamp: actionTimestamp,
        transaction: transaction
      }
    }))

    const result = response.data.portfolioTransactionDelete

    console.log('deleted portfolio transaction', result)
    return result
  },

  async transactionDividend(portfolioId, instrumentId, dps, dateAdded) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('transactionDividend', portfolioId, instrumentId, dps, dateAdded)
      API.graphql(graphqlOperation(portfolioTransactionDividend, {
          portfolioId: portfolioId,
          instrumentId: instrumentId,
          dps: dps,
          dateAdded: dateAdded ? dateAdded : new Date().toISOString()
        }
      )).then(response => {
        console.log('created dividend transaction', response.data.portfolioTransactionDividend)
        resolve(response.data.portfolioTransactionDividend)
      }).catch(reject)
    })
  },
  async portfolioShareEntryDelete(portfolioId, instrumentId) {
    if (DEBUG) {
      console.log('portfolioShareEntry delete', portfolioId, instrumentId)
    }
    const resp = await API.graphql(graphqlOperation(deletePortfolioShareEntry, {
      portfolioId: portfolioId,
      instrumentId: instrumentId
    }))
    console.log('deleted portfolioShareEntry: ', {portfolioId, instrumentId})
    const result = resp.data.portfolioShareEntryDelete
    return result
  },
  async portfolioEtfEntryDelete(portfolioId, instrumentId) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('portfolioEtfEntry delete', portfolioId, instrumentId)
      API.graphql(graphqlOperation(deletePortfolioEtfEntry, {
          portfolioId: portfolioId,
          instrumentId: instrumentId
        }
      )).then(updated => {
        console.log('deleted portfolioEtfEntry: ', updated.data.portfolioEtfEntryDelete)
        resolve(updated.data.portfolioEtfEntryDelete)
      }).catch(reject)
    })
  },
  async backtrack(portfolioId, years) {
    if (!portfolioId || !years) {
      throw new Error("PORTFOLIO_API.backtrack: portfolioId + years parameters are required!")
    }
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('backtrack', portfolioId, years)
      API.graphql(graphqlOperation(getBacktrackedPortfolio, {
          portfolioId,
          years
        }
      )).then(result => {
        console.log('backtracked portfolio: ', result.data.getBacktrackedPortfolio)
        resolve(result.data.getBacktrackedPortfolio)
      }).catch(reject)
    })
  },
}


const SCREENER_API = {
  async screenerPositionGroups(assetClass) {
    const query = screenerPositionGroups(assetClass)
    const group = "SCREENER_" + assetClass + "_DEFAULT"
    console.log('screenerPositionGroups group', group)
    const resultSet = await API.graphql(graphqlOperation(query,
        {groupId: group}
      )
    ).catch((e) => {
      console.error('Failed to fetch screener position group for group ' + group, e)
    })
    if (DEBUG) console.log('screenerPositionGroups result', resultSet.data)
    return resultSet.data.getPositionGroup
  },
  async getScreenerResultColumns(assetClassId) {
    const resultSet = await API.graphql(graphqlOperation(getScreenerResultColumns,
        {assetClass: assetClassId}
      )
    ).catch((e) => {
      console.error('Failed to fetch screener result columns (getScreenerResultColumns)' + assetClassId, e)
    })
    console.log('getScreenerResultColumns result for ' + assetClassId, resultSet.data.getScreenerResultColumns)
    return resultSet.data.getScreenerResultColumns
  }
}

const SHARE_SCREENER_API = {
  async renameShareScreenerConfiguration(configuration) {
    let result = null
    if (DEBUG) console.log('renameShareScreenerConfiguration', configuration)
    if (configuration.id) {
      result = await API.graphql(graphqlOperation(renameScreener, {
        input: {
          id: configuration.id,
          name: configuration.name
        }
      }))
    }
    return result
  },
  async updateShareScreenerHits(id, hits) {
    if (DEBUG) console.log('updateShareScreenerHits', id, hits)
    let result = null
    if (!id) {
      return null
    }
    let timestamp = new Date(Date.now()).toISOString()
    result = await API.graphql(graphqlOperation(updateScreenerHits, {
      input: {
        id: id,
        lastHits: hits,
        lastHitsUpdated: timestamp
      }
    }))
    if (DEBUG) console.log('updateShareScreenerHits', result)
    return result
  },
  async saveShareScreenerConfiguration(configuration) {
    console.log('saveShareScreenerConfiguration', configuration)

    let filters = []
    for (let filter of configuration.filters.items) {
      let id = filter.id ? filter.id : null
      console.log('filter: ', filter)
      filters.push({
        id: id,
        itemId: filter.item.id,
        min: filter.min,
        max: filter.max
      })
    }

    let valueFilters = []
    for (let filter of configuration.valueFilters.items) {
      const id = filter.id ? filter.id : null
      valueFilters.push({
        id: id,
        itemId: filter.item.id,
        values: filter.values.map(item => item.id) // Array of String, containing the ids
      })
    }

    let configurationId = configuration.id ? configuration.id : null
    let input = {
      id: configurationId,
      name: configuration.name,
      screenerConfigurationSectorId: configuration.sector.id,
      screenerConfigurationRegionId: configuration.region.id,
      screenerConfigurationMarketCapCategoryId: configuration.marketCapCategory.id,
      filters: filters,
      valueFilters: valueFilters
    }

    console.log("saveShareScreenerConfiguration input", input)
    let response = await API.graphql(graphqlOperation(saveScreenerConfiguration, {input: input}))
    console.log("saveShareScreenerConfiguration response", response)
    return response.data.saveScreenerConfiguration
  },
  async firstFilterStepShareScreenerEntries() {
    const sectors = await MASTER_DATA_API.topLevelSectors()
    const regions = await MASTER_DATA_API.topLevelRegions()
    const marketCaps = await MASTER_DATA_API.marketCapitalizationCategorys()
    return [
      {
        key: 'region',
        title: 'Markt wählen',
        categories: regions.map(x => {
          return {
            key: x.id,
            title: x.name
          }
        })
      },
      {
        key: 'sector',
        title: 'Branche wählen',
        categories: sectors.map(x => {
          return {
            key: x.id,
            title: x.name
          }
        })
      },
      {
        key: 'marketCapCategory',
        title: 'Unternehmensgröße',
        categories: marketCaps.map(x => {
          return {
            key: x.id,
            title: x.name
          }
        })
      }
    ]
  },
  async deleteShareScreenerConfiguration(configuration) {
    let result = null

    if (configuration.id) {
      result = await API.graphql(graphqlOperation(deleteScreenerConfiguration, {
        input: {
          id: configuration.id
        }
      }))
      return result.data.deleteScreenerConfiguration
    }
  }
}

const ETF_SCREENER_API = {
  async getFinancialDataItemFilterValues(finDataItemID, assetClassID) {
    if (!finDataItemID || !assetClassID) {
      throw new Error("ETF_SCREENER_API.getFinancialDataItemFilterValuesByIdAndAssetClass finDataItemID and assetClassID must be set.")
    }
    const result = await API.graphql(graphqlOperation(getFinancialDataItemFilterValuesByIdAndAssetClass, {
      finDataItemID,
      assetClassID
    }))
    return result.data.getFinancialDataItem
  },
  async renameEtfScreenerConfiguration(configuration) {
    let result = null
    if (DEBUG) {
      console.log('renameEtfScreenerConfiguration', configuration)
    }
    if (configuration.id) {
      result = await API.graphql(graphqlOperation(updateEtfScreenerConfiguration, {
        input: {
          id: configuration.id,
          name: configuration.name
        }
      }))
    }
    return result
  },
  async updateEtfScreenerHits(id, hits) {
    if (DEBUG) {
      console.log('updateEtfScreenerHits', id, hits)
    }
    let result = null
    if (!id) {
      return null
    }
    const timestamp = new Date(Date.now()).toISOString()
    result = await API.graphql(graphqlOperation(updateEtfScreenerConfiguration, {
      input: {
        id: id,
        lastHits: hits,
        lastHitsUpdated: timestamp
      }
    }))
    if (DEBUG) {
      console.log('updateEtfScreenerHits', result)
    }
    return result
  },
  async updateEtfScreenerColumns(id, columns) {
    if (!id || !Array.isArray(columns)) {
      return null
    }

    const result = await API.graphql(graphqlOperation(updateEtfScreenerConfiguration, {
      input: {
        id,
        resultColumns: columns
      }
    }))

    if (DEBUG) {
      console.log('updateEtfScreenerColumns', result)
    }

    return result.data.updateEtfScreenerConfiguration
  },
  async saveEtfScreenerConfiguration(configuration) {
    console.log('saveEtfScreenerConfiguration', configuration)

    let rangeFilters = []
    for (let filter of configuration.rangeFilters.items) {
      const id = filter.id ? filter.id : null
      console.log('saveEtfScreenerConfiguration rangeFilter: ', filter)
      rangeFilters.push({
        id: id,
        itemId: filter.item.id,
        min: filter.min,
        max: filter.max
      })
    }

    let valueFilters = []
    for (let filter of configuration.valueFilters.items) {
      const id = filter.id ? filter.id : null
      console.log('saveEtfScreenerConfiguration valueFilter: ', filter)
      valueFilters.push({
        id: id,
        itemId: filter.item.id,
        values: filter.values.map(item => item.id) // Array of String, containing the ids
      })
    }

    const configurationId = configuration.id ? configuration.id : null
    const input = {
      assetClass: configuration.assetClass.id,
      id: configurationId,
      lastHits: configuration.lastHits,
      name: configuration.name,
      rangeFilters: rangeFilters,
      valueFilters: valueFilters,
      resultColumns: configuration.resultColumns ? configuration.resultColumns : [] // TODO correct?
    }
    console.log("saveEtfScreenerConfiguration input", input)
    const response = await API.graphql(graphqlOperation(saveEtfScreenerConfiguration, {input: input}))
    console.log("saveEtfScreenerConfiguration response", response)
    return response.data.saveEtfScreenerConfiguration
  },
  async deleteEtfScreenerConfiguration(configuration) {
    let result = null
    if (configuration.id) {
      result = await API.graphql(graphqlOperation(deleteEtfScreenerConfiguration, {
        input: {
          id: configuration.id,
        }
      }))
      return result.data.deleteEtfScreenerConfiguration
    }
  }
}

const WATCHLIST_API = {

  async listWatchlists(userId, nextToken) {
    return new Promise((resolve, reject) => {
        API.graphql(graphqlOperation(myWatchlists, {owner: userId, nextToken: nextToken})).then(p => {
            if (DEBUG) {
              console.log("listWatchlists", p)
            }
            resolve(p.data.listOwnerWatchlist?.items)
          }
        ).catch(reject)
      }
    )
  },
  async createWatchlist(obj) {
    let result = await API.graphql(graphqlOperation(createWatchlist, {
      input: {
        name: obj.name
      }
    }))
    return result.data.createWatchlist
  },
  async renameWatchlist(obj) {
    if (obj.id) {
      let result = await API.graphql(graphqlOperation(renameWatchlist, {
        input: {
          id: obj.id,
          name: obj.name
        }
      }))
      return result.data.updateWatchlist
    } else {
      return this.createWatchlist(obj)
    }
  },
  async createWatchlistEntry(watchlistId, instrumentId) {

    if (DEBUG) console.log('createWatchlistEntry: ', watchlistId, instrumentId)

    const response = await API.graphql(graphqlOperation(addWatchlistEntry, {
        watchlistId: watchlistId,
        instrumentId: instrumentId
      }
    ))
    console.log('inserted watchlistEntry', watchlistId, instrumentId, response.data.addWatchlistEntry)
    return response.data.addWatchlistEntry
  },
  async deleteWatchlistEntry(watchlistId, instrumentId) {
    if (DEBUG) console.log('deleteWatchlistEntry: ', watchlistId, instrumentId)
    const response = await API.graphql(graphqlOperation(deleteWatchlistEntry, {
      input: {
        watchlistId: watchlistId,
        instrumentId: instrumentId
      }
    }))
    const result = response.data.deleteWatchlistEntry
    if (DEBUG) console.log('deleteWatchlistEntry result', result)
    return result
  },

  async deleteWatchlist(item) {
    let result = null

    if (item.id)
      result = await API.graphql(graphqlOperation(deleteWatchlist, {
        input: {
          id: item.id
        }
      }))
    console.log('deleted', result)
  },
}

const TIME_SERIES_API = {
  getSectorTimeSeries(sectorId, shareId, startValue) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('getSectorTimeSeries with sectorId ', sectorId, 'shareId ', shareId, " startValue ", startValue)
      API.graphql(graphqlOperation(getSectorTimeSeries, {
        sectorId: sectorId,
        shareId: shareId,
        startValue: startValue
      })).then(fetched => {
        if (DEBUG) console.log('found timeseries', fetched.data.getSectorTimeSeries)
        let ts = null
        if (fetched.data.getSectorTimeSeries && fetched.data.getSectorTimeSeries.length > 0) {
          ts = fetched.data.getSectorTimeSeries
        }
        resolve(ts)
      }).catch(reject)
    })
  }
}

const DEMO_TOOL_API = {
  getDemoToolAssets() {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('sortedDemoToolAssets')
      API.graphql({
        query: sortedDemoToolAssets,
        authMode: store.getters["auth/publicQueryAuthMode"]
      }).then(fetched => {
        resolve(fetched.data.searchDemoToolAssets.items)
      }).catch(reject)
    })
  },
  getDemoToolSparplanzinsen() {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('getDemoToolSparplanzinsen')
      API.graphql({
        query: getDemoToolSparplanzinsen,
        authMode: store.getters["auth/publicQueryAuthMode"]
      }).then(fetched => {
        resolve(fetched.data.getDemoToolAsset)
      }).catch(reject)
    })
  }
}

const {findShareByIdForRating, calculateShareRating} = require('@/views/protected/finTools/rate/shares/graphql')

const {getSpeakerMessageRecipient} = require("@/js/finQueries")

const SHARE_RATING_API = {
  async getDefaultShareRating(shareId, subscriptionFeatureEnabled) {
    if (DEBUG) console.log('get default share rating for share id ' + shareId)
    try {
      let result = await API.graphql(graphqlOperation(findShareByIdForRating, {
        shareId
      }))

      if (!subscriptionFeatureEnabled) {
        return {
          name: 'default-rating',
          inactive: true,
          share: result.data.getShare
        }
      }

      // no sector is set -> don't try to calc fair value
      if (!result.data.getShare.company.sectorLevel1) {
        console.log("no sector level 1 assigned", result)
        return {share: result.data.getShare}
      }

      let rating = {
        name: 'default-rating',
        shareRatingShareId: result.data.getShare.id,
        shareRatingSectorId: result.data.getShare.company.sectorLevel1.id,
        conditions: [{
          initial: true,
          financialDataItemId: 'peRatio',
          basis: 'CURRENT_YEAR',
          weight: 100
        }],
      }

      return await this.calculateShareRating(rating)
    } catch (error) {
      console.log("error calling getDefaultShareRating for share id " + shareId, error)
      throw error
    }
  },
  getAndRecalcShareRating(shareRatingId) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('get and recalculate Share Rating')
      API.graphql(graphqlOperation(calculateShareRating, {input: {id: shareRatingId}}))
        .then(fetched => {
          resolve(fetched.data.calculateShareRating)
        }).catch(reject)
    })
  },
  calculateShareRating(shareRating) {
    shareRating['save'] = false
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('calculate Share Rating')
      API.graphql(graphqlOperation(calculateShareRating, {input: shareRating}))
        .then(fetched => {
          resolve(fetched.data.calculateShareRating)
        }).catch(reject)
    })
  },
  calculateAndSaveShareRating(shareRating) {
    shareRating['save'] = true
    console.log("shareRating: ", shareRating)
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('calculate and save Share Rating')
      API.graphql(graphqlOperation(calculateShareRating, {input: shareRating}))
        .then(fetched => {
          resolve(fetched.data.calculateShareRating)
        }).catch(reject)
    })
  },
}

const STRATEGY_API = {
  searchSortedShareStrategyCategories() {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('search sorted share strategy category')
      API.graphql(graphqlOperation(searchSortedShareStrategyCategories))
        .then(fetched => {
          resolve(fetched.data.searchShareStrategyCategorys.items)
        }).catch(reject)
    })
  },

  searchSortedEtfStrategyCategories() {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('search sorted share strategy category')
      API.graphql(graphqlOperation(searchSortedEtfStrategyCategories))
        .then(fetched => {
          resolve(fetched.data.searchEtfStrategyCategorys.items)
        }).catch(reject)
    })
  }
}

const SPEAKER_API = {

  //Administration / specific Message from SpeakerMessages
  getSpecificMessageAdmin(id) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log("getSpecificMessageAdmin", id)
      API.graphql(graphqlOperation(getSpeakerAdminMessage, {id: id}))
        .then(fetched => {
          resolve(fetched.data.gr_listSpeakerMessages.items[0])
        }).catch(reject)
    })
  },

  //User / specific Message from SpeakerMessageRecipient
  getSpecificMessage(id) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log("getSpecificMessage", id)
      API.graphql(graphqlOperation(getSpeakerMessageRecipient, {id: id}))
        .then(fetched => {
          resolve(fetched.data.getSpeakerMessageRecipient)
        }).catch(reject)
    })
  },

  //User / all unread Messages from SpeakerMessageRecipient
  getUnreadMessages(owner, limit = 10, nextToken = undefined) {
    return new Promise((resolve, reject) => {
      API.graphql(graphqlOperation(getSpeakerUserUnreadMessages, {
        owner: owner,
        limit: limit,
        nextToken: nextToken,
      }))
        .then(fetched => {
          resolve({
            nextToken: fetched.data.listOwnerSpeakerMessageRecipientByStatus.nextToken,
            items: fetched.data.listOwnerSpeakerMessageRecipientByStatus.items.filter(item => item != null)
          })
        })
        .catch(e => {
          const errorToIgnore = "Cannot return null for non-nullable type: 'SpeakerMessage' within parent 'SpeakerMessageRecipient'"
          if (e.errors.filter((item) => !(item.message.startsWith(errorToIgnore))).length > 0) {
            console.error("Failed to get unread messages", e)
          } else {
            resolve({
              nextToken: e.data.listOwnerSpeakerMessageRecipientByStatus.nextToken,
              items: e.data.listOwnerSpeakerMessageRecipientByStatus.items.filter(item => item != null)
            })
          }
        })
    })
  },

  //Administration / all Messages from SpeakerMessages
  getAdminMessages: async (limit = 100, nextToken = undefined, filter) => {
    const params = {limit: limit, nextToken: nextToken}
    if (filter) {
      params.filter = filter
    }

    let result = undefined
    const resultSet = await API.graphql(graphqlOperation(listSpeakerAdminMessages, params)
    ).catch((e) => {
      const errorToIgnore = "Cannot return null for non-nullable type: 'SpeakerMessage' within parent 'SpeakerMessageRecipient'"
      if (e.errors.filter((item) => !(item.message.startsWith(errorToIgnore))).length > 0) {
        console.error('Failed to fetch listSpeakerAdminMessages', e)
        return undefined
      } else {
        result = e.data.gr_listSpeakerMessages
      }
    })

    return result ? result : resultSet?.data.gr_listSpeakerMessages
  },
  //User / only own and appended messages per id
  getUserMessages: async (limit = 100, nextToken = null, userId) => {
    const params = {limit: limit, owner: userId, nextToken: nextToken}

    let result = undefined
    const resultSet = await API.graphql(graphqlOperation(getSpeakerUserMessages, params))
      .catch((e) => {
        const errorToIgnore = "Cannot return null for non-nullable type: 'SpeakerMessage' within parent 'SpeakerMessageRecipient'"
        if (e.errors.filter((item) => !(item.message.startsWith(errorToIgnore))).length > 0) {
          console.error('Failed to fetch getSpeakerUserMessages', e)
          return undefined
        } else {
          result = e.data.listOwnerSpeakerMessageRecipient
        }
      })

    return result ? result : resultSet?.data.listOwnerSpeakerMessageRecipient
  },

  //Administration / update existing message
  updateMessage(input) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log("updateMessage", input)
      API.graphql(graphqlOperation(updateSpeakerMessage, {input: input}))
        .then(fetched => {
          resolve(fetched.data.gr_updateSpeakerMessage)
        }).catch(reject)
    })
  },

  updateReadAt(msg) {
    if (msg.status === 'READ') {
      return msg
    }

    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('update speaker message recipient readAt from: ', msg.id)
      API.graphql(graphqlOperation(
        updateSpeakerMessageReadAt,
        {
          id: msg.id,
          now: new Date().toISOString(),
          createdAt: msg.createdAt,
          status: 'READ'
        }))
        .then(fetched => {
          resolve(fetched.data.updateSpeakerMessageRecipient)
        }).catch(reject)
    })
  },

  updateReceivedAt(id) {
    return new Promise((resolve, reject) => {
      if (DEBUG) console.log('updateReceivedAt', id)
      API.graphql(graphqlOperation(updateSpeakerMessageReceived, {id: id, now: new Date().toISOString()}))
        .then(fetched => {
          resolve(fetched.data.updateSpeakerMessageRecipient)
        }).catch(reject)
    })
  }
}

const testVersion = async () => {
  if (DEBUG) console.log("store.getters[\"auth/publicQueryAuthMode\"]", store.getters["auth/publicQueryAuthMode"])
  let result = await API.graphql({
    query: testVersionQuery,
    authMode: store.getters["auth/publicQueryAuthMode"],
    fetchPolicy: 'network-only'
  })
  if (DEBUG) console.log("testVersion", result)
  return result.data.getVersion
}

const SCREENER_UTIL = {
  setRangeFilter(screenerFilter, filter) {
    if (filter && (filter.min || filter.max)) {
      screenerFilter[filter.item.id] = {range: [filter.min, filter.max]}
    }
  },
  getItemFilter(itemId, selection) {
    if (!selection || !selection.id) return
    const value = selection.id
    if (DEBUG) console.log("getItemFilter for value", value)
    if (value.startsWith("<") || value.startsWith(">")) {
      const parsed = value.match(/(<=|>=|>|<)([0-9.]*)/)
      const compareSign = parsed[1]
      const limit = parsed[2]
      if (DEBUG) console.log("compareSign", compareSign, "limit", limit)
      let compareOperator = compareSign.startsWith("<") ? "lt" : "gt"
      if (compareSign.endsWith("=")) {
        compareOperator += "e"
      }
      return {[itemId]: {[compareOperator]: parseFloat(limit)}}
    } else {
      return {[itemId]: {eq: value}}
    }
  },
  getItemFilterNotEqual(itemId, selection) {
    if (!selection || !selection.id) return
    const value = selection.id
    if (DEBUG) console.log("getItemFilterNotEqual for value", value)
    return {[itemId]: {ne: value}}
  },
  matchOne(screenerFilter, filter) {
    if (filter && (filter.values)) {
      if (!screenerFilter.and) {
        screenerFilter.and = []
      }

      if (filter.item.itemId === "launchDate") {
        let condition = !Array.isArray(filter.values) ? filter.values : filter.values[0]
        if (!condition) {
          return
        }
        let numberOfYears = /\d+/.exec(condition.id)
        if (!numberOfYears) {
          return
        }
        const compareSign = condition.id.match(/(<=|>=|>|<)/)[0]
        let now = new Date()
        now.setYear(now.getFullYear() - numberOfYears)
        let ageDate = now.toISOString().substring(0, 10)
        let compareOperator = compareSign.startsWith("<") ? "gt" : "lt"  // !! Age > 1 Year  => launchDate < (now - 1 Year)
        if (compareSign.endsWith("=")) {
          compareOperator += "e"
        }
        screenerFilter.and.push({[filter.item.itemId]: {[compareOperator]: ageDate}})

      } else {
        if (!Array.isArray(filter.values)) {
          screenerFilter.and.push(this.getItemFilter(filter.item.itemId, filter.values))
        } else if (Array.isArray(filter.values) && filter.values.length > 0) {
          if (filter.values.length === 1) {
            screenerFilter.and.push(this.getItemFilter(filter.item.itemId, filter.values[0]))
          } else {
            screenerFilter.and.push({or: filter.values.map(val => this.getItemFilter(filter.item.itemId, val))})
          }
        }
      }
      if (screenerFilter.and.length === 0) {
        delete screenerFilter.and
      }
    }
  },
  matchNone(screenerFilter, filter) {
    if (filter && (filter.values)) {
      if (!screenerFilter.and) {
        screenerFilter.and = []
      }
      if (!Array.isArray(filter.values)) {
        screenerFilter.and.push(this.getItemFilter(filter.item.itemId, filter.values))
      } else if (Array.isArray(filter.values) && filter.values.length > 0) {
        if (filter.values.length === 1) {
          screenerFilter.and.push(this.getItemFilterNotEqual(filter.item.itemId, filter.values[0]))
        } else {
          screenerFilter.and.push({and: filter.values.map(val => this.getItemFilterNotEqual(filter.item.itemId, val))})
        }
      }

      if (screenerFilter.and.length === 0) {
        delete screenerFilter.and
      }
    }
  },
  getShareScreenerFilter(screener) {
    let screenerFilter = {
      restricted: {eq: false},
      active: {eq: true},
      covered: {eq: true},
      delisted: {eq: false}
    }
    if (DEBUG) {
      console.log('getShareScreenerFilter', screener)
    }

    const regionID = screener?.region?.id
    if (regionID && regionID !== 'ALL') {
      screenerFilter.shareRegionId = {eq: regionID}
    }

    const sectorID = screener?.sector?.id
    if (sectorID && sectorID !== 'ALL') {
      const sector = '' + sectorID + '*'
      screenerFilter.gicsCode = {wildcard: sector}
    }

    const marketCapCategoryID = screener?.marketCapCategory?.id
    if (marketCapCategoryID && marketCapCategoryID !== 'ALL') {
      const midSize = 1000
      const largeSize = 10000
      let sizeFilter = {lt: midSize}
      if (marketCapCategoryID === 'MIDCAP') {
        sizeFilter = {range: [midSize, largeSize]}
      } else if (marketCapCategoryID === 'LARGECAP') {
        sizeFilter = {gte: largeSize}
      }
      screenerFilter.marketCapital = sizeFilter
    }
    if (screener.filters.items) {
      screener.filters.items.forEach(filter => {
        this.setRangeFilter(screenerFilter, filter)
      })

      if (DEBUG) {
        console.log('level 2 filter', screenerFilter)
      }
    }

    if (screener.valueFilters.items) {
      screener.valueFilters.items.forEach(valueFilter => {
        if (valueFilter.item.itemId === "sectorExclusionId") {
          this.matchNone(screenerFilter, valueFilter)
        } else {
          this.matchOne(screenerFilter, valueFilter)
        }
      })
      if (DEBUG) {
        console.log('valueFilter', screenerFilter)
      }
    }

    if (Object.keys(screenerFilter).length === 0) {
      screenerFilter = null
    }
    return screenerFilter
  },
  getEtfScreenerFilter(etfScreener) {
    console.log("getEtfScreenerFilter etfScreener", etfScreener)
    let etfScreenerFilter = {
      restricted: {eq: false},
      active: {eq: true},
      covered: {eq: true},
      delisted: {eq: false},
      assetType: {eq: etfScreener.assetClass?.id || etfScreener.assetClass},
    }

    if (etfScreener.rangeFilters.items) {
      console.log('etfScreener.rangeFilters.items', etfScreener.rangeFilters.items)
      etfScreener.rangeFilters.items.forEach(rangeFilter => {
        this.setRangeFilter(etfScreenerFilter, rangeFilter)
      })
      if (DEBUG) {
        console.log('ETF rangeFilter', etfScreenerFilter)
      }
    }

    if (etfScreener.valueFilters.items) {
      etfScreener.valueFilters.items.forEach(valueFilter => {
        this.matchOne(etfScreenerFilter, valueFilter)
      })
      if (DEBUG) {
        console.log('ETF valueFilter', etfScreenerFilter)
      }
    }

    if (Object.keys(etfScreenerFilter).length === 0) {
      etfScreenerFilter = null
    }
    return etfScreenerFilter
  }
}

// Exporting all public API
module.exports = {
  finShareAPI: SHARE_API,
  finEtfAPI: ETF_API,
  finInstrumentAPI: INSTRUMENT_API,
  finUserAPI: USER_API,
  finCompanyAPI: COMPANY_API,
  finMasterDataAPI: MASTER_DATA_API,
  finScreenerAPI: SCREENER_API,
  finShareScreenerAPI: SHARE_SCREENER_API,
  finEtfScreenerAPI: ETF_SCREENER_API,
  finPortfolioAPI: PORTFOLIO_API,
  finWatchlistAPI: WATCHLIST_API,
  finTimeSeriesAPI: TIME_SERIES_API,
  finDemoToolAPI: DEMO_TOOL_API,
  finShareRatingAPI: SHARE_RATING_API,
  finStrategyAPI: STRATEGY_API,
  finSpeakerAPI: SPEAKER_API,
  testVersion: testVersion,
  SCREENER_UTIL
}
